/* eslint-disable */
export default {
  dialPlaceholder: 'Introduzca el nombre o número',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
